import { observer } from 'mobx-react-lite';
import ElementItem from './ElementItem';
import type { ElementItemProps, ElementItemValueProps } from './types';

export type { ElementItemProps, ElementItemValueProps };
export default observer(ElementItem); // MANUAL OVERRIDE
